<div class="container main-content-area">
    <div class="policy-page card p-5 shadow">
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> 1st May 2025</p>
        <p><strong>Website : </strong> <a href="https://www.lil-champs.com" target="_blank">www.lil-champs.com</a></p>
      
        <p>At Lil Champ’s Happy Bot, we care deeply about the privacy and safety of our users—especially children. This Privacy Policy explains how we collect, use, and protect information shared on our website.</p>
      
        <h3>1. Information We Collect</h3>
        <ul>
          <li>We do not collect any personal data from children.</li>
          <li>We may collect non-personal data like browser type, location (city/state level), and device type for analytics.</li>
          <li>Cookies to improve user experience (you can disable these in your browser settings).</li>
        </ul>
      
        <h3>2. How We Use Your Information</h3>
        <ul>
          <li>Improve website functionality and content.</li>
          <li>Understand what sections are most engaging.</li>
          <li>Monitor and fix technical issues.</li>
        </ul>
      
        <h3>3. Third-Party Tools</h3>
        <p>We may use tools like Google Analytics to track usage data. These tools do not collect personal information or track individual users.</p>
      
        <h3>4. Links to Other Sites</h3>
        <p>Our site may link to other educational resources. We are not responsible for the privacy practices of external websites.</p>
      
        <h3>5. Safety & Compliance</h3>
        <p>This website is intended to be COPPA-friendly and designed to be used with adult supervision. No child-specific personal data is collected or stored.</p>
      
        <h3>6. Contact Us</h3>
        <p>For any concerns or questions about this policy, please email: <a href="mailto:support@lil-champs.com">support&#64;lil-champs.com
        </a></p>
      </div>
        
</div>